"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentationTypeEnum = void 0;
var DocumentationTypeEnum;
(function (DocumentationTypeEnum) {
    DocumentationTypeEnum["NONE"] = "keins";
    DocumentationTypeEnum["PICTURE_BEFORE_AFTER"] = "Bilder vorher/nacher";
    DocumentationTypeEnum["PROTOCOL"] = "Abnahmeprotokoll";
    DocumentationTypeEnum["CUSTOMER_PROTOCOL"] = "Kundenabnahmeprotokoll";
    DocumentationTypeEnum["PROTOCOL_WITH_PICTURES"] = "Bilder und Abnahmeprotokoll";
    DocumentationTypeEnum["PICTURE"] = "Bild (z.B. Klingelschild)";
})(DocumentationTypeEnum = exports.DocumentationTypeEnum || (exports.DocumentationTypeEnum = {}));
//# sourceMappingURL=documentation-type.js.map